module.exports = __webpack_public_path__ + "img/renouvelables.e495969.jpg";